.sidebar-header-container {
    padding: 16px 8px 0 8px;
    color: var(--secondary-sidebar-text);
    font-size: var(--font-small);
}

.sidebar-header-container--top {
    padding: 8px 8px 0 8px;
}
